const translations = {
  'Starting soon': {
    en: 'Starting soon',
    es: 'Proximamente',
    pt: 'Em breve'
  },
  'Started {minutes} minutes ago': {
    en: 'Started {minutes} minutes ago',
    es: 'Iniciado hace {minutes} minutos',
    pt: 'Iniciado há {minutes} minutos'
  },
  'Starts in {minutes} minutes': {
    en: 'Starts in {minutes} minutes',
    es: 'Empieza en {minutes} minutos',
    pt: 'Começa em {minutes} minutos'
  },
  'New': {
    en: 'New',
    es: 'Nuevo',
    pt: 'Novo'
  }
}

export default translations